export default __webpack_public_path__ + "static/rock-tower-4c7c552bb72e8cc3dcaf137e91c2f279.jpg";